export const sortedBusinessOptions = (businessOption, mappingType) => {

    if (!businessOption) {
        return [];
    }

    const mappedOptions = businessOption.map(e => {
        if (mappingType === 'sortMonthlyPrice') {
            return { label: e.businessName, value: e.id };
        } else if (mappingType === 'sortAdministration') {
            return { value: e.businessName, id: e.businessId };
        }
        return null;
    });

    mappedOptions.sort((a, b) => {
        let valueA, valueB;

        if (mappingType === 'sortMonthlyPrice') {
            valueA = a.label.toLowerCase();
            valueB = b.label.toLowerCase();
        } else if (mappingType === 'sortAdministration') {
            valueA = a.value.toLowerCase();
            valueB = b.value.toLowerCase();
        }

        return valueA.localeCompare(valueB);
    });

    return mappedOptions;
}
